import React, { useEffect } from "react";
import propTypes from "prop-types";
// import { Card } from "primereact/card";
import StyleWrapper from "./style";
import { RadioButton } from "primereact/radiobutton";
// import config from "../../../../helpers/config";
import { useTranslation } from "react-i18next";
import tamara from "assets/images/tamara.svg";
import WOW from "assets/gifs/wow.gif";

const LeadProductCard = ({proposal, formik}) => {
  const { t, i18n } = useTranslation();
  const getTitle = (code) => {
    switch (code) {
      case "PRMotorImtiazeCO":
        return {
          title: t("Motor.AlShamel"),
          subTitle: t("Motor.AlShamel_covers"),
          p: t("Motor.AlShamel_covers_2"),
          title_en: "Al Shamel",
        };
      case "MotorImtiazeTP":
        return {
          title: t("Motor.Sanad"),
          subTitle: t("Motor.Third_Party_Liability"),
          p: t("Motor.Third_Party_limit"),
          title_en: "Sanad",
        };
      case "PRMotorImtiazeSP":
        return {
          title: t("Motor.Sanad_Plus"),
          subTitle: t("Motor.owen_damage"),
          p: t("Motor.Sanad_limit"),
          title_en: "Sanad Plus",
        };
      default:
        return {
          title: "",
          subTitle: "",
          p: "",
          title_en: "",
        };
    }
  };
  const isActive = formik.values.proposalCode === proposal.productSubCode;

  return proposal.premium ? (
    <StyleWrapper onClick={(e) => formik.setFieldValue("proposalCode", proposal.productSubCode)}>
      <div className={`card_wrapper ${isActive ? "active" : ""}`}>
        <div className="title_wrapper">
          <h3 className="product_name">{getTitle(proposal.productSubCode).title}</h3>
          <p className="product_description">
            {getTitle(proposal.productSubCode).subTitle} &nbsp;
            {proposal.productSubCode =="PRMotorImtiazeSP" && <img src={WOW} alt="" height={30} />}
          </p>
        </div>
        <div className="price_wrapper">
          <div className="price_details">
            <span className="price"> {proposal.premium} </span>{" "}
            <span className="sar"> {t("POLICY.SAR")} </span>
            <p className="vat">{t("MotorEn.Icluding_vat")}</p>
          </div>
          <RadioButton
            checked={isActive}
            name="proposalCode"
            value={proposal.productSubCode}
            onChange={formik.handleChange}
          />
        </div>
      </div>
    </StyleWrapper>
  ) : (
    ""
  );
};

LeadProductCard.propTypes = propTypes.exact({
  title: propTypes.string.isRequired,
  subTitle: propTypes.string,
  price: propTypes.string.isRequired,
  vat: propTypes.string,
  onSelect: propTypes.func.isRequired,
  isRecommended: propTypes.bool,
  isActive: propTypes.bool.isRequired,
  className: propTypes.string,
}).isRequired;

export default LeadProductCard;
